import {Modal} from "./modal";

/** Класс модального окна с представителями русского космизма. */
class Representatives {
    body = document.body

    /**
     * Конструктор класса.
     *
     * @param {HTMLElement} modal Элемент.
     */
    constructor(modal) {
        this.modal = modal;
        this.photo = this.modal.querySelector(".js-representative-card-photo");
        this.name = this.modal.querySelector(".js-representative-card-name");
        this.description = this.modal.querySelector(".js-representative-card-text");

        this.bindEventListeners();
    }

    /**
     * Прослушиваем события.
     * 
     * @returns {void}
     */
    bindEventListeners() {
        document.addEventListener("click", (e) => {

            if (e.target.classList.contains("js-representative") ||
                e.target.closest(".js-representative")) {
                Modal.open(this.modal);

                const representative = e.target.closest(".js-representative")
                    ? e.target.closest(".js-representative")
                    : e.target;

                const card = {
                    imageSrc: representative.querySelector(".js-representative-photo").getAttribute("src"),
                    name: representative.querySelector(".js-representative-name"),
                    description: representative.querySelector(".js-representative-description")
                }

                this.photo.src = card.imageSrc;
                this.name.innerHTML = card.name.innerHTML;
                this.description.innerHTML = card.description.innerHTML;
            }
        });
    }

    /**
     * Открытие модального окна.
     * 
     * @returns {void}
     */
    showModal = () => {
        this.modal.classList.add("shown");
    }
}

window.addEventListener("load", () => {
    document
        .querySelectorAll(".js-mch-modal[data-modal-name='representatives']")
        .forEach(el => new Representatives(el));
});